var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.isLocating)?_c('div',{staticClass:"loading-overlay"},[_c('div',{staticClass:"spinner"}),_c('p',[_vm._v("正在定位中...")])]):_vm._e(),_c('Delivery',{ref:"deliveryComponent",attrs:{"noAuth":_vm.noAuth,"msg":"Delivery"}}),_c('Footer',{attrs:{"msg":"Footer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }